"use client";

import { DialogHeader } from "../DialogHeader";
import { LinkExchangesList, LinkExchangesGrid } from "@/components/features/wallet/LinkExchanges";
import { useDevice } from "@/hooks";
import { useCreateAccountStore } from "@/store/accountStore";
import { FLOW_TYPES, useConnectStore } from "@/store/connectStore";

interface CexSelectionStepProps {
  title: string;
  subtitle: string;
  exchangeIds: string[];
  onNext: (cex: string) => void;
}

export const CexSelectionStep = ({ title, subtitle, exchangeIds, onNext }: CexSelectionStepProps) => {
  const { updateFormData, setError } = useCreateAccountStore();
  const { isMobile } = useDevice();

  const { flowType } = useConnectStore();
  const isRelink = flowType === FLOW_TYPES.RELINK;

  const handleSelectCex = (cex: string) => {
    updateFormData({ selectedCex: cex });
    setError(null);
    onNext(cex);
  };

  return (
    <div className="flex flex-col flex-1 min-h-0 w-full">
      <DialogHeader centerTitle={isMobile} title={title} subtitle={subtitle} />

      <div className="flex-1 min-h-0 flex flex-col overflow-hidden mt-6">
        <div className="flex-1 min-h-0 overflow-y-auto scrollbar-visible px-2 sm:px-0 sm:pr-6">
          {isMobile && !isRelink ? (
            <LinkExchangesGrid exchangeIds={exchangeIds} handleSelectCex={handleSelectCex} />
          ) : (
            <LinkExchangesList
              exchangeIds={exchangeIds}
              showRemoveButton={isRelink}
              handleSelectCex={handleSelectCex}
            />
          )}
        </div>
      </div>
    </div>
  );
};
